import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { IArea } from '@app/api/interfaces/area.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { AreaModel } from '@app/api/enums/area-model.enum';

export const areasKey = 'areas';

export const areasAdapter = createEntityAdapter<IArea>({
  selectId: area => area.id,
  sortComparer: false,
});

export interface IAreasState extends EntityState<IArea> {
  loading: boolean;
  loaded: boolean;
  loadedByProjectId: Record<string, AreaModel>;
  error: IApiBaseErrorResponse | null;
}

export const initialState: IAreasState = areasAdapter.getInitialState({
  loading: false,
  loaded: false,
  loadedByProjectId: {},
  error: null,
});
